module.exports = require("@swa-ui/personal-info/src/form/PassengerAccommodationsFormFields/MedicalEquipmentFormFields/MedicalEquipmentFormFields.module.scss");